import React from 'react'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'

const AboutUs = () => {
  const { siteInfo } = useSelector((state) => state.user)

  const aboutUsItems = siteInfo?.filter(
    (el) => el.cmsSection === 'aboutUs'
  )

  return (
    <ul className='m-0 list-none px-3 sm:px-0'>
      {aboutUsItems?.map((el) => (
        <li key={el.id}>
          <NavLink to={`/site-info/${el.slug}`}>
            {el.title}
          </NavLink>
        </li>
      ))}
    </ul>
  )
}

export default React.memo(AboutUs)
